import 'reflect-metadata'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './i18n/i18n.js'
import '@drones2bim/potree/build/potree/potree.css'; // Add this line here
import 'ol/ol.css'
import {container} from "tsyringe";
import {ContainerService} from "@drones2bim/geo-spatial-engine";

if (!new class {
    x = undefined
}().hasOwnProperty('x')) throw new Error('Transpiler is not configured correctly');

if (!container.isRegistered(ContainerService)) {
    container.registerSingleton(ContainerService)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
)
